// extracted by mini-css-extract-plugin
export default {"supportText":"ZHpu91znrHXGgba9qh2O"};